import styled from 'styled-components'

export const Description = styled.div`
  padding-top: 8px;
  padding-right: 211px;
  color: #262626;
  font-size: 14px;
  a {
    color: #2684ff;
    padding-left: 4px;
    transition: 200ms;
    &:hover {
      opacity: 0.7;
    }
  }
`

export const CreateCollection = styled.div`
  button {
    color: #2684ff;
    height: 40px;
    float: right;
    font-weight: 700;
    svg {
      margin-right: 8px;
    }
  }
`

export const Alert = styled.div`
  color: #363636;
  border: 1px solid #ffeaa3;
  background-color: #fff9e3;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  svg {
    color: #d48806;
    position: absolute;
    margin-top: 4px;
  }
`

export const AlertTitle = styled.div`
  font-weight: bold;
  padding-left: 25px;
`

export const AlertDescription = styled.div`
  padding-left: 25px;
  a {
    color: #0085ff !important;
    text-decoration: underline !important;
  }
`
